<!-- 客编 -->
<template>
  <BaseFormItem2
    :label="fields.label"
    :labelTips="fields.labelTips"
    :isError="isError"
    :isErrorBlink="isErrorBlink"
    :isShake="isShake"
    :valueConfig="board_type === 'ROGERS' ? '' : 'user_stamp'"
  >
    <BaseRadioGroup2 v-model="val" :isError="isError" @change="handleEmit">
      <BaseTipPopover 
        v-for="item in fields.options"
        :key="item.value" 
        :content="item.tips" 
        :disabled="!item.tips"
      >
        <el-radio-button
          slot="reference"
          :label="item.value"
          :disabled="item.disabled"
        >{{ item.label }}</el-radio-button>
      </BaseTipPopover>
    </BaseRadioGroup2>
  </BaseFormItem2>
</template>

<script>
import { getFR4Fields } from '@@/utils/getFields'

export default {
  props: {
    value: {
      type: Number,
      default: 0
    },
    // 产品类别
    board_type: {
      type: String,
      default: 'FR-4'
    },
  },
  data() {
    return {
      val: this.value,
      isError: false, // 是否显示错误提示样式
      isErrorBlink: false, // 是否显示错误提示样式且闪两下
      isShake: false, // 是否抖动两下
    }
  },
  computed: {
    fields() {
      return getFR4Fields('user_stamp')
    }
  },
  watch: {
    value(newVal) {
      this.val = newVal
    },
  },
  methods: {
    handleEmit() {
      const val = this.val
      this.$emit('input', val)
      this.$emit('change', val)
      this.isShowError(false)
    },
    // 是否显示错误提示样式
    isShowError(isError) {
      this.isError = isError
    },
    // 是否抖动两下
    isShowShake(isShake) {
      this.isShake = isShake
      const timer = setTimeout(() => {
        this.isShake = false
        clearTimeout(timer)
      }, 300)
    },
  }
}
</script>

<style lang="scss">
</style>